window.addEventListener("load", () => {
  const containers = document.querySelectorAll('.wp-block-create-block-link-image');
  containers.forEach(container => {
    const image = container.querySelector('.link-wrapper__image img');
    const links = container.querySelectorAll('.link-wrapper__content__link');

    const textColor = container.querySelector('.link-wrapper__content__link').style.color;
    const arrows = container.querySelectorAll('.link-wrapper__content__link span');
    const height = container.querySelector('.link-wrapper__content').offsetHeight;
    console.log(height);
    container.querySelector('.link-wrapper__image').style.maxHeight = height +'px';
    if (textColor) {
      arrows.forEach(arrow => {
        arrow.style.setProperty('--text', textColor);
      })
    }
    
    links.forEach(link => {
      if (textColor) {
        link.style.setProperty('--text', textColor);
      }

      link.addEventListener('mouseenter', () => {
        image.src = link.dataset.image;
      });
    });
  });
});